import { observable, makeObservable, action } from 'mobx';
import { cloneDeep } from 'lodash';

class SessionStore {
    constructor() {
        makeObservable(this);
    }
    //流式输出结束后是否需要获取会话列表--首次会话时使用
    @observable isNeedGetSessionList = false;
    @action setIsNeedGetSessionList = (flag) => {
        this.isNeedGetSessionList = flag;
    };
    //开启新会话时记录下,后端的会话id是否生成
    @observable isHasNewSessionId = false;
    @action setIsHasNewSessionId = (flag) => {
        this.isHasNewSessionId = flag;
    };
    @observable originSessionList = null; //会话历史列表--整理后
    @action
    setOriginSessionList = (data) => {
        this.originSessionList = data;
    };
    @observable sessionList = {}; //会话历史列表--整理后
    @action
    setSessionList = (data) => {
        this.sessionList = data;
    };
    @observable sessionMap = {}; //会话map---前端显示
    @action setSessionMap = (data) => {
        this.sessionMap = {
            ...this.sessionMap,
            ...data
        };
    };
    //获取当前会话的消息
    getCurSessionMsgs = () => {
        let data = this.originMsgMap[this.currentSessionMapId]?.messages;
        if (!data) {
            return [];
        }
        return cloneDeep(data);
    };
    //当前的会话id
    @observable currentSessionMapId = null;
    @action changeCurrentSessionMapId = (session_id) => {
        this.currentSessionMapId = session_id;
    };
    //会话的消息map--后端的原始数据{session_id: {messages: [],loading: false},session_id2: {messages: [],loading: false}}
    @observable originMsgMap = {};
    @action changeOriginMsgMap = (data) => {
        this.originMsgMap = {
            ...this.originMsgMap,
            ...data
        };
    };
    // 删除指定的 originMsgMap 条目
    @action removeOriginMsg = (sessionId) => {
        try {
            const copy = { ...this.originMsgMap };
            if (copy.hasOwnProperty(sessionId)) {
                delete copy[sessionId];
                this.originMsgMap = copy;
            }
        } catch (e) {
            console.error('removeOriginMsg failed', e);
        }
    };
}
export default new SessionStore();
